import { Dialog } from '@/components/ui/dialog'
import { LOADING_SCREEN_Z_INDEX } from '@/components/ui/loading-screen'
import { useStepUpState } from '@/states/step-up-state'

import { StepUpAuthContent } from './step-up-auth-content'

// Mounted once by the app provider; the axios interceptor opens it when a write answers 403 StepUpRequired.
export function StepUpAuthDialog() {
  const open = useStepUpState((state) => state.open)
  const resolve = useStepUpState((state) => state.resolve)

  return (
    // It interrupts a request mid-flight, so it must sit above any loader that request put up.
    <Dialog open={open} zIndex={LOADING_SCREEN_Z_INDEX + 1} onClose={() => resolve(false)}>
      <Dialog.Title title="Verify it's you" subtitle="This change needs your two-step verification." />
      <Dialog.Content dividers>
        <div data-testid="step-up-dialog">
          <StepUpAuthContent open={open} onVerified={() => resolve(true)} onDismiss={() => resolve(false)} />
        </div>
      </Dialog.Content>
    </Dialog>
  )
}
